import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M11.999 22C7.05569 21.9348 3.06417 17.9433 2.99902 13C3.06417 8.05666 7.05569 4.06514 11.999 3.99999C16.9423 4.06514 20.9339 8.05666 20.999 13C20.9339 17.9433 16.9423 21.9348 11.999 22ZM11.999 5.99999C8.15418 6.0506 5.04963 9.15515 4.99902 13C5.04963 16.8448 8.15418 19.9494 11.999 20C15.8438 19.9494 18.9484 16.8448 18.999 13C18.9484 9.15515 15.8438 6.0506 11.999 5.99999ZM16.999 14H10.999V7.99999H12.999V12H16.999V14ZM20.291 6.70799L17.282 3.70799L18.691 2.29099L21.701 5.29099L20.291 6.70699V6.70799ZM3.70602 6.70799L2.29102 5.29099L5.28202 2.29099L6.69702 3.70799L3.70802 6.70799H3.70602Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Alarm"
);
